import React, { useState } from 'react';
import { useAuth } from '../../../core/context/AuthContext';
import Header from '../../../shared/components/layout/Header';
import Footer from '../../../shared/components/layout/Footer';
import { ToastContainer } from '../../../shared/components/Toast';
import CargaFacturasOS from './CargaFacturasOS';
import GrillaPagosFacturasOS from './GrillaPagosFacturasOS';
import './ContabilidadPage.css';

const tabs = [
  { id: 'carga', label: 'Carga de Facturas' },
  { id: 'pagos', label: 'Pagos Facturas OS' },
];

const CargaFacturasOSPage = () => {
  const { user } = useAuth();
  const [toast, setToast] = useState(null);
  const [vistaActiva, setVistaActiva] = useState('carga');

  return (
    <div className="contabilidad-page">
      <Header />
      <div className="contabilidad-content">
        <div className="page-header">
          <h2 className="page-title-grilla">Facturación — Obras Sociales</h2>
          <span className="page-subtitle">Gestión de facturas y pagos de Obras Sociales — {user?.username}</span>
        </div>

        {/* Tabs */}
        <div className="tabs-container">
          {tabs.map(t => (
            <button
              key={t.id}
              className={`tab-button ${vistaActiva === t.id ? 'active' : ''}`}
              onClick={() => setVistaActiva(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {vistaActiva === 'carga' && (
          <div className="contabilidad-section">
            <CargaFacturasOS onToast={setToast} />
          </div>
        )}

        {vistaActiva === 'pagos' && (
          <div className="contabilidad-section">
            <GrillaPagosFacturasOS />
          </div>
        )}
      </div>
      <Footer />
      <ToastContainer toast={toast} onClose={() => setToast(null)} />
    </div>
  );
};

export default CargaFacturasOSPage;
